var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('div',{staticClass:"wrapper"},[_c('Header',{attrs:{"logo":_vm.footerInfo.logo}}),_c('Body',{attrs:{"homeInfo":_vm.homeInfo,"banner":_vm.homeInfo.banner}}),_c('Footer',{attrs:{"footerInfo":_vm.footerInfo}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }